import { Fragment, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { STYLE_BUTTON_CANCEL_MODAL } from "../../utils/useStyle";
import { ContextLanguage } from "../../context/Context.Language";
import React from "react";

const AccessoryLoadingRing = () => {
  return (
    <svg
      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx={12}
        cy={12}
        r={10}
        stroke="currentColor"
        strokeWidth={4}
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};

const TemplateModal = ({
  open = false,
  setOpen,
  panel,
  title,
  save = null,
  clearInput = null,
  createLoading = null,
  disabled = false,
  hidden,
  error,
  acceptText,
  cancelText = "ยกเลิก",
  showCloseButton = true,
  showSaveButton = true,
  isButtonFullWidth = false,
  classNameModal,
  classNameSave,
  classNameCancel,
}) => {
  const onBackButtonEvent = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };
  }, []);

  const onSubmit = async (e) => {
    if (save) {
      await save(e);
    }
    setOpen(false);
  };

  const onClose = () => {
    if (clearInput) {
      clearInput();
    }
    setOpen(false);
  };
  const { language } = React.useContext(ContextLanguage);

  //   function closeModal() {
  //     setOpen(false);
  //     setTimeout(() => {
  //       const html = document.body.parentNode as HTMLElement | null;
  //       html.classList.add('modal_close');
  //     }, 50);
  // }

  // function openModal() {
  //     setOpen(true);
  //     const html = document.body.parentNode as HTMLElement | null;
  //     html.classList.remove('modal_close');
  // }
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        static
        className={`fixed z-50 inset-0 ${
          language === "TH" ? " font-NotoSansThai " : " font-Poppins "
        }`}
        open={open}
        onClose={() => onClose()}
      >
        <div className="flex items-center justify-center min-h-screen text-center font-Kanit ">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30   transition-opacity" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4"
            enterTo="opacity-100 translate-y-0"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0"
          >
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
              className={`inline-block align-middle bg-white text-left z-20 shadow-xl transform transition-all rounded-xl shadowModal + ${classNameModal} `}
            >
              {panel}
              <div
                className={`${
                  hidden ? " hidden " : ""
                }+" bg-white rounded-xl  z-10 px-6 bottom-0 pb-4 md:pb-6  fixed w-full grid ${
                  isButtonFullWidth
                    ? " grid-cols-1 "
                    : " grid-cols-2 gap-4 md:gap-6 "
                } gap-2"`}
              >
                {error && <div>{error}</div>}
                {showCloseButton && (
                  <button
                    type="button"
                    className={`${STYLE_BUTTON_CANCEL_MODAL} ${classNameCancel} `}
                    onClick={() => onClose()}
                  >
                    {cancelText}
                  </button>
                )}
                {showSaveButton && (
                  <button
                    disabled={disabled}
                    type="button"
                    style={{
                      zIndex: 100,
                    }}
                    className={`${
                      createLoading || disabled
                        ? "bg-gray-400 cursor-not-allowed "
                        : `mx-auto h-h_50 w-full md:h-input  bg-laundry-primary-blue  rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue hover:bg-laundry-gray-80 hover:order-blue duration-0  focus:outline-none text-center`
                    } ${classNameSave} `}
                    onClick={disabled ? () => {} : (e) => onSubmit(e)}
                  >
                    {createLoading ? <AccessoryLoadingRing /> : acceptText}
                  </button>
                )}
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default TemplateModal;
